/* ============================================================
   HERO-SLIDESHOW · Lieblingscap

   Schaltet die Hero-Folien um. Bewusst klein gehalten und ohne
   jede Verbindung zu Shopifys Varianten-, Preis- oder Warenkorb-
   Mechanik - dieses Skript liest und schreibt ausschliesslich im
   eigenen Hero-Element.

   Schutz gegen Mehrfachstart: Jeder Hero wird ueber ein Merkmal am
   Element selbst nur einmal in Betrieb genommen. Ein doppelt
   geladenes Skript haengt dadurch keine zweiten Zuhoerer an.
   ============================================================ */
(function () {
  'use strict';

  var LEISER_MODUS = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
    : false;

  function starte(hero) {
    if (!hero || hero.dataset.lcBereit === '1') return;
    hero.dataset.lcBereit = '1';

    var folien = hero.querySelectorAll('[data-lc-slide]');
    var kreise = hero.querySelectorAll('[data-lc-thumb]');
    if (folien.length < 2) return;

    var aktuell = 0;
    var uhr = null;
    var tempo = parseInt(hero.dataset.lcTempo, 10) || 6000;
    var automatisch = hero.dataset.lcAuto === 'true' && !LEISER_MODUS;

    function zeige(nummer) {
      aktuell = (nummer + folien.length) % folien.length;

      folien.forEach(function (folie, i) {
        var aktiv = i === aktuell;
        folie.classList.toggle('ist-aktiv', aktiv);
        folie.setAttribute('aria-hidden', aktiv ? 'false' : 'true');

        // Verdeckte Folien aus der Tab-Reihenfolge nehmen
        folie.querySelectorAll('a, button').forEach(function (el) {
          if (aktiv) {
            el.removeAttribute('tabindex');
          } else {
            el.setAttribute('tabindex', '-1');
          }
        });

        // Nur das sichtbare Video laeuft - spart Akku und Datenvolumen
        folie.querySelectorAll('video').forEach(function (v) {
          if (aktiv) {
            var versuch = v.play();
            if (versuch && versuch.catch) { versuch.catch(function () {}); }
          } else {
            v.pause();
          }
        });
      });

      kreise.forEach(function (kreis, i) {
        kreis.setAttribute('aria-selected', i === aktuell ? 'true' : 'false');
      });

      setzeKreisHoehe();
    }

    /* Die Kreise direkt ueber die Ueberschrift der sichtbaren Folie
       legen. Gemessen statt geraten, weil die Texthoehe je nach Folie
       und Bildschirmbreite anders ausfaellt. */
    var kreisReihe = hero.querySelector('.lc-hero__thumbs');
    function setzeKreisHoehe() {
      if (!kreisReihe) return;
      var folie = folien[aktuell];
      if (!folie) return;
      var block = folie.querySelector('.lc-hero__text-block');
      if (!block) return;

      var oben = block.getBoundingClientRect().top - hero.getBoundingClientRect().top;
      var platz = kreisReihe.offsetHeight + 20;
      kreisReihe.style.top = Math.max(16, oben - platz) + 'px';
    }

    function weiter() { zeige(aktuell + 1); }

    /* Die Klasse haelt zusaetzlich den Fortschrittsring an. Ohne sie
       liefe der Ring weiter, obwohl die Slideshow steht. */
    function starteUhr() {
      hero.classList.remove('lc-hero--pause');
      if (!automatisch || uhr) return;
      uhr = setInterval(weiter, tempo);
    }
    function stoppeUhr() {
      hero.classList.add('lc-hero--pause');
      if (!uhr) return;
      clearInterval(uhr);
      uhr = null;
    }

    kreise.forEach(function (kreis, i) {
      kreis.addEventListener('click', function () {
        zeige(i);
        stoppeUhr();
        starteUhr();
      });
    });

    /* Pausieren, solange der Besucher liest oder bedient */
    hero.addEventListener('mouseenter', stoppeUhr);
    hero.addEventListener('mouseleave', starteUhr);
    hero.addEventListener('focusin', stoppeUhr);
    hero.addEventListener('focusout', starteUhr);

    /* Im Hintergrundtab nicht weiterlaufen lassen */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stoppeUhr(); } else { starteUhr(); }
    });

    zeige(0);
    starteUhr();

    window.addEventListener('resize', setzeKreisHoehe);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(setzeKreisHoehe);
    }
  }

  function starteAlle(bereich) {
    (bereich || document).querySelectorAll('[data-lc-hero]').forEach(starte);
  }

  starteAlle();

  /* Im Theme-Editor wird der Abschnitt bei jeder Aenderung neu geladen */
  document.addEventListener('shopify:section:load', function (e) {
    starteAlle(e.target);
  });
})();